module.exports = __webpack_public_path__ + "img/0738ce6deba5455284b27696f43386ac-640.c7dcc10c.jpg";